import { UserRound, ShieldCheck, Code2, UsersRound } from "lucide-react";
import { TRUST } from "@/data/content";
import { Reveal } from "./Reveal";

const ICONS = { user: UserRound, shield: ShieldCheck, code: Code2, users: UsersRound };

export const TrustStrip = () => (
  <section id="instructor" data-testid="trust-strip" className="border-b border-slate-200 bg-white">
    <div className="mx-auto grid max-w-[1360px] grid-cols-1 gap-y-5 px-5 py-7 sm:grid-cols-2 lg:grid-cols-4 lg:px-10">
      {TRUST.map((t, i) => {
        const Icon = ICONS[t.icon];
        return (
          <Reveal key={t.icon} delay={i * 0.08} className={`flex items-center gap-4 lg:px-6 ${i ? "lg:border-l lg:border-slate-200" : ""}`}>
            <div data-testid={`trust-item-${i + 1}`} className="flex items-center gap-4">
              <span className="grid h-14 w-14 shrink-0 place-items-center rounded-full border-2 border-blue-100 bg-gradient-to-b from-white to-blue-50 text-blue-700 shadow-sm">
                <Icon className="h-6 w-6" />
              </span>
              <p className="max-w-[230px] text-[15px] leading-snug text-slate-800">{t.text}</p>
            </div>
          </Reveal>
        );
      })}
    </div>
  </section>
);
